import { Building2, Heart, Dumbbell, MapPin, User } from 'lucide-react';

// Available icons for site areas
export const ICON_OPTIONS = [
    { value: 'Building2', label: 'Building', icon: Building2 },
    { value: 'Coffee', label: 'Coffee/Dining', icon: Building2 },
    { value: 'TreePine', label: 'Nature/Gardens', icon: Building2 },
    { value: 'Heart', label: 'Wellness/Health', icon: Heart },
    { value: 'Dumbbell', label: 'Fitness', icon: Dumbbell },
    { value: 'MapPin', label: 'Location', icon: MapPin },
    { value: 'User', label: 'People', icon: User },
];
